// src/modules/app-views/landingPages/pages/Document/tabs/WebsiteIaTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useCallback } from 'react';
import { Row, Col, Form } from 'antd';
import { useDocumentContext } from 'components/core/DocumentProvider';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import AIPromptPanel from '../../components/AIPromptPanel';
import WebsitePreviewPanel from '../../components/WebsitePreviewPanel';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const WebsiteIaTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();
  const { form } = useSimpleFormContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const pageType = Form.useWatch('pageType', form);
  const url = Form.useWatch('url', form);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const documentId = data?._id;

  // True when user selected "already exists" — show external URL preview
  const isExistingPage = pageType === 'exists';

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // Sync generated HTML into form state so it gets saved on submit
  const handleHtmlGenerated = useCallback(
    newHtml => {
      form?.setFieldValue('htmlContent', newHtml);
    },
    [form]
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="lpWebsiteIa" isFetching={loading} data={data} />

      <Row gutter={16} style={{ height: 'calc(100vh - 320px)', minHeight: 500, marginTop: 16 }}>

        {isExistingPage ? (
          // Existing page — full width preview loaded from external URL
          <Col span={24} style={{ height: '100%' }}>
            <WebsitePreviewPanel
              documentId={documentId}
              htmlContent={data?.htmlContent}
              externalUrl={url}
            />
          </Col>
        ) : (
          <>
            {/* Left 40% — AI prompt to generate the page */}
            <Col span={10} style={{ height: '100%' }}>
              <AIPromptPanel documentId={documentId} onHtmlGenerated={handleHtmlGenerated} />
            </Col>

            {/* Right 60% — live preview of AI-generated HTML */}
            <Col span={14} style={{ height: '100%' }}>
              <WebsitePreviewPanel documentId={documentId} htmlContent={data?.htmlContent} />
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default WebsiteIaTab;
